<template>
    <div>
        <h2 style="text-align: center">ตั้งค่าโบนัสเซลล์</h2>
        <br/>
        <div class="form-group row">
            <div class="col-sm-3 text-right">
                <label>ชื่อรายการ</label>
            </div>
            <div class="col-sm-7">
                <input class="form-control"
                       type="text" v-model="form.name"/>
            </div>
        </div>
        <div class="form-group row">
            <div class="col-sm-3 text-right">
                <label>ยอดขาย ตั้งแต่</label>
            </div>
            <div class="col">
                <input type="text"
                       placeholder="จำนวนเริ่มต้น"
                       class="form-control" v-model="form.start_price"/>
            </div>
            <div class="col">
                <input type="text"
                       placeholder="จำนวนสิ้นสุด"
                       class="form-control" v-model="form.end_price"/>
            </div>
            <div class="col">
                <input type="text"
                       placeholder="โบนัส"
                       class="form-control" v-model="form.bonus"/>
            </div>
            <div class="col">
                <button class="btn btn-success" @click="addSaleBonus">+</button>
            </div>
        </div>
        <!--show bonus-->
        <div class="form-group row" v-for="(data,index) in rate_bonus_array">
            <div class="col-sm-3 text-right">
                <label>ยอดขาย ตั้งแต่</label>
            </div>
            <div class="col">
                <input type="text"
                       placeholder="จำนวนเริ่มต้น"
                       class="form-control" v-model="data.start_price"/>
            </div>
            <div class="col">
                <input type="text"
                       placeholder="จำนวนสิ้นสุด"
                       class="form-control" v-model="data.end_price"/>
            </div>
            <div class="col">
                <input type="text"
                       placeholder="โบนัส"
                       class="form-control" v-model="data.bonus"/>
            </div>
            <div class="col">
                <button class="btn btn-danger" @click="removeBonusSaleArray(index)">-</button>
            </div>
        </div>
        <br/>
        <div class="col text-center">
            <button type="button" @click="submitData"
                    class="btn btn-success">
                <icon name="save"></icon>
                บันทึก</button>&nbsp&nbsp
            <button type="button" @click="cancelData"
                    class="btn btn-outline-secondary">
                <icon name="times"></icon> ยกเลิก
            </button>
        </div>
        <!--<pre class="alert alert-primary">{{rate_bonus_sale}}</pre>-->

    </div>
</template>

<script>
    import { mapState } from "vuex"

    export default {
        name: "sale-bonus-modal",
        created(){
            this.$store.dispatch("RateBonusSale/clearDataForm");
        },
        data(){
          return {
              rate_bonus_sale : []
          }
        },
        computed:{
            ...mapState({
                form:state=>{
                    return state.RateBonusSale.rateBonusForm;
                },
                user:state=>{
                    return state.Auth.user
                },
                rate_bonus_array : state=>{
                    return state.RateBonusSale.rate_bonus_array;
                }
            })
        },
        methods:{
            addSaleBonus(){
                this.form.user_id = this.user.id;
                this.$store.dispatch("RateBonusSale/addSaleBonusArray");
            },
            removeBonusSaleArray(index){
                this.$store.dispatch("RateBonusSale/removeRateBonusArray",index);
            },
            submitData(){
                this.rate_bonus_sale = []
                this.form.user_id = this.user.id;
                if(this.rate_bonus_array.length < 1){
                    if(!this.form.name){
                        alert("กรุณากรอกชื่อรายการ")
                    }
                    else if(!this.form.start_price){
                        alert("กรุณาใส่จำนวนเริ่มต้น");
                    }
                    else if(!this.form.end_price){
                        alert("กรุณาใส่จำนวนสิ้นสุด");
                    }
                    else if(!this.form.bonus){
                        alert("กรุณาใส่โบนัส");
                    }
                    else{
                        this.rate_bonus_sale.push(this.form);
                        this.$store.dispatch("RateBonusSale/save",{
                            data : this.rate_bonus_sale
                        });
                        this.$emit("submit",1);
                    }
                }
                else{
                    this.rate_bonus_array.forEach(rate=>{
                        if(rate.start_price){
                            let info = {
                                name : this.form.name,
                                start_price : rate.start_price,
                                end_price : rate.end_price,
                                bonus : rate.bonus,
                                user_id : this.form.user_id
                            };
                            this.rate_bonus_sale.push(info);
                        }
                    });
                    this.rate_bonus_sale.push(this.form);
                    this.$store.dispatch("RateBonusSale/save",{
                        data : this.rate_bonus_sale
                    });
                    this.$emit("submit",1);
                }
            },
            cancelData(){
                this.$emit("submit",0);
            }
        },
    }
</script>

<style scoped>

</style>